/** Valores devueltos por GET /users/type (UsuarioTipo en backend). */
export enum UsuarioTipo {
  SBD = 'SBD',
  SB = 'SB',
  SBP = 'SBP',
  ASP = 'ASP',
  FAN = 'FAN',
  ABONADO = 'ABONADO',
  ABONADO_BONIFICADO = 'ABONADO_BONIFICADO',
}

export type ProductSliderKey = 'soybeticopremium' | 'soybetico' | 'soyverdiblanco' | 'palmerin';

export type DetailBannerKey =
  | 'soy-betico-premium'
  | 'soy-betico'
  | 'soy-betico-digital'
  | 'palmerin';
